import PropTypes from 'prop-types';
import React from 'react';
import { createUseStyles } from 'react-jss';

import OverallProgress from './overall-progress';
import Regions from './regions';

const useStyles = createUseStyles({
  regions: {
    composes: ['pr24'],
    maxHeight: 320,
  },
  trophies: {
    composes: ['flex-rows', 'flex-start', 'pl15', 'pr6'],
  },
});

const TrophiesViewComponent = React.memo(({ lmap }) => {
  const classes = useStyles();
  return (
    <div className={classes.trophies}>
      <OverallProgress />
      <Regions lmap={lmap} />
    </div>
  );
});

TrophiesViewComponent.propTypes = {
  lmap: PropTypes.shape().isRequired,
};

TrophiesViewComponent.displayName = 'TrophiesViewComponent';

export default TrophiesViewComponent;
